class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-drawer');
    this.notificationSuccess = this.notification.querySelector('.cart-drawer__success');

    this.button = document.getElementById('cart-icon-bubble');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.init();
  }

  init() {
    this.querySelectorAll('button[type="button"].cart-drawer__close').forEach((closeButton) =>
    closeButton.addEventListener('click', this.close.bind(this))
    );
    const vatForm = this.querySelector('#cart-drawer-vat-form');
    if (vatForm && vatForm.children.length === 0) {
      SufioVAT.onCart({
        selectors: "#cart-drawer-vat-form"
      });
    }
  }


  open() {
    this.notification.classList.add('animate', 'active');
    this.classList.add('active');
    this.button.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');





    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.classList.remove('active');
    this.button.classList.remove('active');
    if (this.notificationSuccess) this.notificationSuccess.classList.add('hidden');

    // Clean up the exemptify observer if it exists
    if (this.exemptifyObserver) {
      this.exemptifyObserver.disconnect();
      this.exemptifyObserver = null;
    }

    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      if (this.notificationSuccess) this.notificationSuccess.classList.remove('hidden');
      if (this.header) this.header.reveal();
    this.open();
    this.init();
    this.reinitializeExemptifyValidation();
    this.updateExemptifyButtonPrice();
  }


  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-products'
      },
      {
        id: 'cart-notification-links'
      },
      {
        id: 'cart-notification-warning'
      },
      {
        id: 'cart-notification-extra'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  reinitializeExemptifyValidation() {
    const container = document.getElementById('ExemptifyCartValidationSnippet');
    if (!container) return;

    const existingScript = container.querySelector('script[src*="modules4u.biz/shopify/exemptify/js/validate_vat_v1.js.php"]');
    if (!existingScript) return;

    const src = existingScript.getAttribute('src');
    if (!src) return;

    existingScript.remove();

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    container.appendChild(script);
  }

  updateExemptifyButtonPrice(retryCount = 0) {
    const exemptifyButton = document.querySelector('.exemptify-button');
    const exemptifyButtonAlt = document.querySelector('button[class*="exemptify"]');
    const exemptifyButtonName = document.querySelector('button[name*="exemptify"]');
    
    const targetButton = exemptifyButton || exemptifyButtonAlt || exemptifyButtonName;
    
    if (targetButton) {
      const mainPriceElement = document.getElementById('checkout-cart-price');
      const exemptifyPriceElement = targetButton.querySelector('#checkout-cart-price');
      
      if (mainPriceElement && exemptifyPriceElement) {
        exemptifyPriceElement.innerHTML = mainPriceElement.innerHTML;
      }
    } else {
      // Only retry a limited number of times
      if (retryCount < 5) {
        setTimeout(() => {
          this.updateExemptifyButtonPrice(retryCount + 1);
        }, 200);
      }
      
      // Set up a mutation observer to watch for it (only once)
      this.setupExemptifyButtonWatcher();
    }
  }

  setupExemptifyButtonWatcher() {
    // Only set up the observer if we don't already have one
    if (this.exemptifyObserver) return;

    this.exemptifyObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is the exemptify button or contains it
            const exemptifyButton = node.classList?.contains('exemptify-button') 
              ? node 
              : node.querySelector?.('.exemptify-button');
            
            if (exemptifyButton) {
              // Found the exemptify button, update its price
              const mainPriceElement = document.getElementById('checkout-cart-price');
              const exemptifyPriceElement = exemptifyButton.querySelector('#checkout-cart-price');
              
              if (mainPriceElement && exemptifyPriceElement) {
                exemptifyPriceElement.innerHTML = mainPriceElement.innerHTML;
              }
              
              // Disconnect the observer since we found the button
              this.exemptifyObserver.disconnect();
              this.exemptifyObserver = null;
            }
          }
        });
      });
    });

    // Start observing the document body for changes
    this.exemptifyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && target !== this.button  && !target.closest('cart-drawer')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartLink extends HTMLElement {
  constructor() {
    super();

    this.cartNotification = document.querySelector('cart-drawer');
    if (this.cartNotification) {
       
      this.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.cartNotification.header) this.cartNotification.header.reveal();
        this.cartNotification.open();
      });
    }
  }

}

customElements.define('cart-link', CartLink);

if (!customElements.get('cart-drawer-items')) {


  class CartNotificationItems extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('cart-drawer-shopping-cart-line-item-status');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target);
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-products',
          section: 'cart-notification-products',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-links',
          section: 'cart-notification-links',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-warning',
          section: 'cart-notification-warning',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-extra',
          section: 'cart-notification-extra',
          selector: '.shopify-section'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }

    addProduct(id, quantity) {
      const body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          const cartItems = document.getElementById('main-cart-items');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        
          }));
          cartItems.scrollIntoView();

          // Update exemptify button price
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.updateExemptifyButtonPrice();
          }

          this.disableLoading();
        }).catch((e) => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }



    updateQuantity(line, quantity, name, input) {
      this.max = input.max;      
      if (this.max) {
        if (quantity > input.max) {
          document.getElementById(`Line-item-error-${line}`)
            .querySelector('.notification-cart-item__error-text')
            .innerHTML = window.cartStrings.quantityError.replace(
              '[quantity]',
              input.max
            );
          quantity = input.max;
        }
      }
      
      this.enableLoading(line);


      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });


      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          // Update exemptify button price
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.updateExemptifyButtonPrice();
          }

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
        }).catch((e) => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }

    updateLiveRegions(line, itemCount) {
      // console.log(line);
      // if (this.currentItemCount === itemCount) {
      //   document.getElementById(`Line-item-error-${line}`)
      //     .querySelector('.notification-cart-item__error-text')
      //     .innerHTML = window.cartStrings.quantityError.replace(
      //       '[quantity]',
      //       document.getElementById(`Quantity-${line}`).value
      //     );
      // }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-drawer-cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      line = line + 1;
      document.getElementById('cart-drawer').classList.add('cart__items--disabled');
      this.querySelectorAll(`#cart-drawer-product-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      document.getElementById('cart-drawer').classList.remove('cart__items--disabled');
    }
  }

  customElements.define('cart-drawer-items', CartNotificationItems);
  
}

class NotificationCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'), event.target);
    });
  }
}

customElements.define('notification-cart-remove-button', NotificationCartRemoveButton);

class CartGiftOffers extends HTMLElement {
  constructor() {
    super();
    this.giftOffers = [];
    this.processedGifts = new Set();
    this.isProcessing = false;

    // Global guard to prevent duplicate gift additions across multiple instances
    if (!window.__cartGiftProcessedVariants) {
      window.__cartGiftProcessedVariants = {};
    }

    this.init();
  }

  init() {
    // Read auto-add flag from data attribute (defaults to false if not explicitly true)
    this.autoAdd = this.dataset.autoAdd === 'true';

    const giftOffersData = this.dataset.giftOffers;
    if (giftOffersData) {
      try {
        this.giftOffers = JSON.parse(giftOffersData);
      } catch (e) {
        console.error('Failed to parse gift offers:', e);
        return;
      }
    }

    console.log('[CartGiftOffers] init', {
      datasetGiftOffers: giftOffersData,
      parsedGiftOffers: this.giftOffers,
      autoAdd: this.autoAdd
    });

    this.observeCartChanges();
    setTimeout(() => this.checkAndAddGifts(), 100);
  }

  observeCartChanges() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-gift-offers') {
          const giftOffersData = this.dataset.giftOffers;
          if (giftOffersData) {
            try {
              this.giftOffers = JSON.parse(giftOffersData);
            } catch (e) {
              console.error('Failed to parse gift offers:', e);
            }
          }
        }
      }

      console.log('[CartGiftOffers] Mutation observed, re-checking gifts', {
        mutations,
        giftOffers: this.giftOffers
      });
      this.checkAndAddGifts();
    });

    const warningElement = document.getElementById('cart-notification-warning');
    if (warningElement) {
      observer.observe(warningElement, {
        childList: true,
        subtree: true,
      });
    }

    observer.observe(this, {
      attributes: true,
      attributeFilter: ['data-gift-offers', 'data-cart-total'],
    });

    document.addEventListener('cart:updated', () => {
      console.log('[CartGiftOffers] cart:updated event received, scheduling re-check');
      setTimeout(() => this.checkAndAddGifts(), 100);
    });
  }

  async checkAndAddGifts() {
    if (this.giftOffers.length === 0 || this.isProcessing) return;

    if (!this.autoAdd) {
      console.log('[CartGiftOffers] auto-add disabled, skipping');
      return;
    }

    console.log('[CartGiftOffers] checkAndAddGifts:start', {
      isProcessing: this.isProcessing,
      giftOffers: this.giftOffers
    });

    this.isProcessing = true;

    try {
      let cartData = await this.getCartData();
      if (!cartData) return;

      const cartTotal = cartData.total_price || 0;
       console.log('[CartGiftOffers] checkAndAddGifts:cartData', {
        cartTotal,
        items: cartData.items
      });

      // Collect unique variant ids that should be present as gifts
      const variantsToEnsure = new Set();

      for (const offer of this.giftOffers) {
        const threshold = parseInt(offer.threshold);
        const variantGid = offer.variantGid;

        if (!variantGid || !threshold) continue;
        if (cartTotal < threshold) continue;

        const variantId = this.extractVariantId(variantGid);
        if (!variantId) continue;

        variantsToEnsure.add(variantId);
      }

      // Ensure each qualifying variant is present at most once as a gift
      for (const variantId of variantsToEnsure) {
        const giftKey = `${variantId}-gift`;

        // If we've already processed this variant once in this instance, never add it again
        if (this.processedGifts.has(giftKey)) {
          console.log('[CartGiftOffers] skipping variant, already processed', {
            variantId,
            giftKey
          });
          continue;
        }

        // If we've already processed this variant globally (across instances), skip
        if (window.__cartGiftProcessedVariants[giftKey]) {
          console.log('[CartGiftOffers] skipping variant, already processed globally', {
            variantId,
            giftKey
          });
          continue;
        }

        const isGiftInCart = this.isGiftInCart(cartData, variantId);
        console.log('[CartGiftOffers] variant check', {
          variantId,
          isGiftInCart
        });

        if (!isGiftInCart) {
          console.log('[CartGiftOffers] adding gift to cart', { variantId });
          // Mark as processed globally immediately to guard against races
          window.__cartGiftProcessedVariants[giftKey] = true;
          await this.addGiftToCart(variantId);
        }

        // Mark this variant as processed so we never auto-add it again
        this.processedGifts.add(giftKey);
      }
    } finally {
      console.log('[CartGiftOffers] checkAndAddGifts:end');
      this.isProcessing = false;
    }
  }

  extractVariantId(gid) {
    const match = gid.match(/\/ProductVariant\/(\d+)/);
    return match ? match[1] : null;
  }

  isGiftInCart(cartData, variantId) {
    if (!cartData || !cartData.items || !cartData.items.length) return false;

    const numericVariantId = parseInt(variantId);

    return cartData.items.some((item) => {
      if (!item || item.variant_id !== numericVariantId) return false;

      const props = item.properties || {};
      // Treat presence of the special _Gifted property as a gift flag, regardless of value
      if (Object.prototype.hasOwnProperty.call(props, '_Gifted')) {
        return true;
      }

      return false;
    });
  }

  async getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return null;
      return await response.json();
    } catch (e) {
      console.error('Failed to fetch cart data:', e);
      return null;
    }
  }

  async addGiftToCart(variantId) {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (!cartDrawerItems) return;

    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _Gifted: 'true',
          },
        },
      ],
      sections: cartDrawerItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      console.log('[CartGiftOffers] addGiftToCart:request', {
        variantId,
        body: JSON.parse(body)
      });

      const response = await fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        body,
      });

      if (!response.ok) {
        console.error('[CartGiftOffers] addGiftToCart:response error', {
          status: response.status,
          statusText: response.statusText
        });
        throw new Error('Failed to add gift to cart');
      }

      const state = await response.text();
      const parsedState = JSON.parse(state);
      console.log('[CartGiftOffers] addGiftToCart:parsedState', {
        item_count: parsedState.item_count,
        sections: Object.keys(parsedState.sections || {})
      });

      cartDrawerItems.classList.toggle('is-empty', parsedState.item_count === 0);

      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      cartDrawerItems.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        elementToReplace.innerHTML = cartDrawerItems.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateExemptifyButtonPrice();
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {
      console.error('Failed to add gift to cart:', e);
    }
  }
}

customElements.define('cart-gift-offers', CartGiftOffers);
